

function sameHeight(sel, opt) {
	var nodes = document.querySelectorAll(sel);
	if (!nodes.length > 0) return;

	var row = opt.rows;
	var rowNodes = void 0;
	var max = void 0;
	var width = void 0;

	var handler = function handler(e) {
		if (e) e.stopImmediatePropagation();

		width = window.innerWidth;

		if (opt.breakpoints) {
			Object.keys(opt.breakpoints).forEach(function (point) {
				if (opt.breakpoints[point] && width <= point) {
					row = opt.breakpoints[point].rows;
				}
			});
		}

		for (var i = 0; i < nodes.length; i += row) {
			max = 0;
			rowNodes = Array.prototype.slice.call(nodes, i, i + row);

			for (var j = 0; j < rowNodes.length; j++) {
				rowNodes[j].setAttribute('style', 'height:auto;');
				if (rowNodes[j].clientHeight > max) max = rowNodes[j].clientHeight;
			}

			for (var k = 0; k < rowNodes.length; k++) {
				rowNodes[k].setAttribute('style', 'height:' + max + 'px');
			}
		}
	};

	window.addEventListener('resize', handler);
	handler();
}
export default sameHeight;



